import colors from './colors'
import constants from './constants'
import fonts from './fonts'

const theme = {colors, constants, fonts}

export {theme as default}


// WEBPACK FOOTER //
// ./assets/common/theme/theme.js